var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "사업안내",
            "tabActive": "오시는길",
            "bg": "/images/sub/business/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("사업안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("오시는길")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "direction-sheet",
    attrs: {
      "color": "primary"
    }
  }, [_c('tit', {
    staticClass: "tit--sm white--text"
  }, [_vm._v("4호선 길음역 10번출구, 4호선 미아사거리역 3번출구에서 각각 도보 10분거리")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "map-wrap"
  }, [_c('iframe', {
    staticClass: "map",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3160.7570230790298!2d127.02745197643169!3d37.60787712175542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cbc860f7c06a1%3A0x15eef13f3fae6d9b!2z7ISc7Jq47Yq567OE7IucIOyEseu2geq1rCDtlZjsm5Tqs6Hrj5kgODgtMjIy!5e0!3m2!1sko!2skr!4v1732067274140!5m2!1sko!2skr",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('v-card', {
    staticClass: "map-card",
    attrs: {
      "flat": "",
      "tile": "",
      "color": "grey"
    }
  }, [_c('div', {
    staticClass: "map-card__inner"
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h3', [_vm._v("주소")])]), _c('v-col', [_vm._v("서울시 성북구 하월곡동 88-222")])], 1), _c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h3', [_vm._v("전화")])]), _c('v-col', [_vm._v("02-6232-0277")])], 1), _c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h3', [_vm._v("이메일")])]), _c('v-col', [_vm._v("felix2025@naver.com")])], 1)], 1)])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }